module.exports = __webpack_public_path__ + "static/media/check-select-dark.7be0f28d.svg";